module.exports = "<p>\r\n  manage-contact works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-contact/manage-contact.component.html
// module id = ./src/app/manage-contact/manage-contact.component.html
// module chunks = main